var _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPhotoGallery(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#b0daed",
    d: "M22.75 6v12A4.754 4.754 0 0 1 18 22.75H6A4.75 4.75 0 0 1 1.25 18V6A4.754 4.754 0 0 1 6 1.25h12A4.754 4.754 0 0 1 22.75 6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#62d8b6",
    d: "M14.75 19.001v3.75H6a4.75 4.75 0 0 1-4.75-4.75v-2.73l3.16-2.11a2.74 2.74 0 0 1 3.17.09l3.49 2.62 3.38 2.53a.74.74 0 0 1 .3.6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffde76",
    d: "M8.625 9.125a2.5 2.5 0 1 0 0-5 2.5 2.5 0 0 0 0 5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#4cc19d",
    d: "M22.75 13.04V18A4.754 4.754 0 0 1 18 22.75H6a4.7 4.7 0 0 1-1.55-.26l11-11a2.74 2.74 0 0 1 3.17-.52z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoGallery);
export default __webpack_public_path__ + "static/media/photo-gallery.7bb174f94c5f4ae6ad45db0e29a4dd96.svg";
export { ForwardRef as ReactComponent };